"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var ConvergenceIcon = function ConvergenceIcon(_ref) {
  var width = _ref.width,
    height = _ref.height,
    className = _ref.className,
    viewBox = _ref.viewBox,
    ariaAttrs = _ref.ariaAttrs;
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    className: className,
    width: width,
    height: height,
    viewBox: viewBox,
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, ariaAttrs), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#000",
    "fill-rule": "evenodd",
    d: "M3.38 14.655a.99.99 0 0 1 .677.349l.025.029-.177.159c-.002 0-.004 0-.005.003l-.005.006-1.089.977s-.002 0-.003.002c-.002 0-.002.003-.004.004l-.074.068-.015-.018c-.368-.421-.35-1.003.038-1.353a.852.852 0 0 1 .578-.228c.018 0 .035 0 .054.002M17.957 8.22c-.356-3.76-3.019-6.936-6.627-7.902-2.62-.703-5.275-.23-7.473 1.329A9.126 9.126 0 0 0 .02 8.426c-.17 2.31.761 4.622 1.736 6.104-.459.713-.405 1.668.2 2.362l.35.4c.087.1.212.162.345.17h.031a.498.498 0 0 0 .334-.127l.052-.048.442.534a.5.5 0 1 0 .771-.637l-.467-.566.372-.334.481.553a.497.497 0 0 0 .705.048.498.498 0 0 0 .05-.705l-.493-.564.187-.168a.5.5 0 0 0 .043-.7l-.348-.401v-.001a1.978 1.978 0 0 0-1.37-.69 1.777 1.777 0 0 0-.932.197C1.657 12.512.87 10.499 1.02 8.5a8.12 8.12 0 0 1 3.417-6.037c1.95-1.384 4.306-1.804 6.634-1.18 3.207.86 5.575 3.685 5.893 7.046.038.305.813 7.218-5.745 8.55.233-.555.716-1.522 1.707-3.112.508-.815 1.088-1.925 1.075-3.27-.043-4.228-3.543-7.767-4.929-8.463-.128-.065-.519-.258-.84-.027-.152.11-.254.388-.225.573.197 1.26.007 2.328-.564 3.183l-.02-.031c-.263-.405-.47-.724-.826-.752a.654.654 0 0 0-.469.189c-.805.9-2.152 2.79-2.127 5.339.021 1.997 1.294 3.707 3.325 4.463a.5.5 0 0 0 .622-.692 4.778 4.778 0 0 1-.335-3.357l.635.429a.5.5 0 0 0 .664-.093c.02-.023.065-.082.078-.106.421-.727.62-1.666.565-2.624.855.375 1.504 1.642 1.446 2.953a.501.501 0 0 0 .48.522c.263-.015.507-.203.52-.48.088-2.032-1.1-3.865-2.649-4.084a.707.707 0 0 0-.604.2.772.772 0 0 0-.22.643c.086.675.011 1.368-.192 1.922l-.46-.312a.752.752 0 0 0-.56-.112.733.733 0 0 0-.473.317.745.745 0 0 0-.062.13 5.777 5.777 0 0 0-.182 3.234c-.873-.627-1.584-1.616-1.598-2.963-.018-1.898.853-3.39 1.548-4.275l.034.053c.262.403.468.722.824.749a.65.65 0 0 0 .468-.19c.854-.96 1.262-2.203 1.2-3.628 1.252.942 3.891 3.826 3.926 7.3.01.86-.267 1.677-.925 2.73C10.146 16.337 10 17.288 10 17.507a.503.503 0 0 0 .563.493c2.455-.307 4.35-1.3 5.631-2.95 2.233-2.874 1.782-6.684 1.763-6.83"
  }));
};
ConvergenceIcon.propTypes = {
  width: _propTypes.default.string,
  height: _propTypes.default.string,
  viewBox: _propTypes.default.string,
  className: _propTypes.default.string,
  ariaAttrs: _propTypes.default.object
};
ConvergenceIcon.defaultProps = {
  width: '18px',
  height: '18px',
  viewBox: '0 0 18 18',
  className: 'arrow-icon'
};
var _default = exports.default = ConvergenceIcon;